import Triangle from "@/assets/icons/triangle.svg?react";
import { ToggleIndicatorProps } from "./types";

export const ToggleIndicator: React.FC<ToggleIndicatorProps> = ({
  isClosed,
  setIsClosed,
}) => {
  return (
    <Triangle
      className={`absolute right-[-5px] cursor-pointer ${isClosed ? "top-[10px]" : "top-0 rotate-180"}`}
      onClick={(e) => {
        e.stopPropagation(); // イベントの伝播を停止
        setIsClosed(!isClosed);
      }}
    />
  );
};
